import { call, put, takeEvery, select, delay, all } from 'redux-saga/effects';
import * as templatesActions from '../actions/templatesActions';
import { getAllTemplatesRequest } from '../../api/templates/getAllTemplatesRequest';
import { deleteTemplateRequest } from '../../api/templateCard/deleteTemplateRequest';
import { errorProcessing } from '../../../Employees/api/errorProcessing';
import history from '../../../../common/history';
import showSuccessWindow from '../../../../common/components/successPopup/successPopup';
import { successDeleteSelectedTemplates } from '../../components/TemplateCard/popup/success';

const getActiveProfileId = state => {
  return (
    state.Authorization &&
    state.Authorization.activeProfile &&
    state.Authorization.activeProfile.profileId
  );
};

function* getAllTemplatesSaga(action) {
  let activeProfileId = yield select(getActiveProfileId);
  if (activeProfileId) {
    try {
      const response = yield call(getAllTemplatesRequest, activeProfileId);
      yield put(templatesActions.getAllTemplatesSuccess(response));
    } catch (e) {
      yield put(templatesActions.getAllTemplatesFailure(errorProcessing(e)));
    }
  } else {
    yield delay(500);
    activeProfileId = yield select(getActiveProfileId);
    activeProfileId
      ? yield put(templatesActions.getAllTemplates(action.payload))
      : history.push('/authorization/profiles');
  }
}

function* deleteSelectedTemplatesSaga(action) {
  let activeProfileId = yield select(getActiveProfileId);
  if (activeProfileId) {
    try {
      if (action.payload) {
        const response = yield all(
          action.payload.map(item =>
            call(deleteTemplateRequest, activeProfileId, action.payload)
          )
        );
        yield put(templatesActions.getAllTemplates());
        const deleteCount =
          response &&
          response.reduce((acc, res) => (res.success ? acc++ : acc), 0);
        showSuccessWindow(successDeleteSelectedTemplates(deleteCount));
        yield put(templatesActions.deleteSelectedTemplatesSuccess(deleteCount));
      }
    } catch (err) {
      let errData = errorProcessing(err);
      yield put(templatesActions.deleteSelectedTemplatesFailure(errData));
    }
  } else {
    history.push('/authorization/profiles');
  }
}

export function* templatesWatcher() {
  yield takeEvery(
    templatesActions.getAllTemplates.toString(),
    getAllTemplatesSaga
  );
  yield takeEvery(
    templatesActions.deleteSelectedTemplates.toString(),
    deleteSelectedTemplatesSaga
  );
}
